import React from "react";
import { ConfigProvider } from "antd";

const LayoutWrapper = ({ children }) => {
  return (
    <ConfigProvider
      theme={{
        token: {
          fontFamily: "Poppins, sans-serif",
          colorPrimary: "#1677ff",
        },
      }}
    >
      {children}
    </ConfigProvider>
  );
};

export default LayoutWrapper;
